// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { WebPubSubJsonProtocolImpl } from "./webPubSubJsonProtocol";
import { WebPubSubJsonReliableProtocolImpl } from "./webPubSubJsonReliableProtocol";
/**
 * Return the "json.webpubsub.azure.v1" protocol
 */
export const WebPubSubJsonProtocol = () => {
    return new WebPubSubJsonProtocolImpl();
};
/**
 * Return the "json.reliable.webpubsub.azure.v1" protocol
 */
export const WebPubSubJsonReliableProtocol = () => {
    return new WebPubSubJsonReliableProtocolImpl();
};
//# sourceMappingURL=index.js.map